import PropTypes from 'prop-types';
import SnackbarSystem from '@ui/systems/SnackbarSystem';

import { connectComponent } from '../../lib/connectComponent';
import {
	getUserCanEditWorkspaceMemberRole,
	getUserCanDeleteWorkspaceMember,
	getUserCanDowngradeWorkspaceMember
}
	from '../../selectors/workspaces';
import WorkspaceMemberWithRole from '../../components/WorkspaceMemberWithRole/WorkspaceMemberWithRole';
import WorkspaceMember from '../../entities/workspaceMember';
import { VALID_ASSIGNABLE_ROLES, AVAILABLE_ROLES } from '../../entities/workspaceRole';
import Container from '../Container';
import { getCurrentUserID } from '../../selectors/currentUser';
import { actionResultIsError } from '../../lib/reduxUtils';
import { isNotAllowedOrNotFound } from '../../errors/common';

export class WorkspaceMemberWithRoleContainer extends Container {
	constructor( props ) {
		super( props );

		this._onEditRoleClicked = this._onEditRoleClicked.bind( this );
	}

	updateWorkspaceMemberRole( roleID ) {
		const { workspaceID, member, updateWorkspaceMemberRole } = this.props;
		const { showSuccessMessage, showErrorMessage } = SnackbarSystem.shared();

		const successMessage = { title: 'The user role has been successfully updated.' };
		const errorMessage = { title: 'Oops! something went wrong! Try again.' };

		return updateWorkspaceMemberRole( workspaceID, member.id, roleID )
			.then( ( result ) => {
				if ( actionResultIsError( result ) ) {
					throw result.payload;
				}

				showSuccessMessage( successMessage );
			} ).catch( error => !isNotAllowedOrNotFound( error ) && showErrorMessage( errorMessage ) );
	}

	_onEditRoleClicked( roleID ) {
		const { props: { member } } = this;

		if ( member.roleID === roleID ) return;

		// Show confirmation popup only if new role is limited
		if ( roleID === 'limited' ) {
			this.showAsyncActionConfirmation(
				`Edit ${member.user.name} workspace role?`,
				'Yes, confirm',
				'Cancel',
				() => this.updateWorkspaceMemberRole( roleID ),
				'Any projects owned by this person will be transferred to the Workspace owner.'
			);
		} else this.updateWorkspaceMemberRole( roleID );
	}

	render() {
		const {
			props: { member, canEdit, canDelete, canDowngrade }
		} = this;

		return (
			<WorkspaceMemberWithRole
				member={member}
				roles={member.isOwner ? AVAILABLE_ROLES : VALID_ASSIGNABLE_ROLES}
				canEdit={canEdit}
				onRoleChange={this._onEditRoleClicked}
				showActionsMenu={canDelete}
				showDowngradeOption={canDowngrade}
			/>
		);
	}
}

WorkspaceMemberWithRoleContainer.propTypes = {
	workspaceID: PropTypes.number.isRequired,
	member: PropTypes.instanceOf( WorkspaceMember ),
	canEdit: PropTypes.bool,
	canDelete: PropTypes.bool,
	canDowngrade: PropTypes.bool,
	updateWorkspaceMemberRole: PropTypes.func,
	currentUserID: PropTypes.number
};

WorkspaceMemberWithRoleContainer.defaultProps = {
	member: null,
	canEdit: true,
	canDelete: false,
	canDowngrade: false,
	updateWorkspaceMemberRole: () => {},
	currentUserID: undefined
};

export default connectComponent( ( state, props ) => ( {
	canEdit: getUserCanEditWorkspaceMemberRole( state, props ),
	canDelete: getUserCanDeleteWorkspaceMember( state, props ),
	canDowngrade: getUserCanDowngradeWorkspaceMember( state, props ),
	currentUserID: getCurrentUserID( state, props )
} ), true )( WorkspaceMemberWithRoleContainer );
